import { WrappedBoolean } from 'app/core/kh-utils/wrapped-boolean';
import { WrappedString } from 'app/core/kh-utils/wrapped-string';
import { environment } from 'env/environment';
import { DateTime } from 'luxon';

export function stringWrapper(text: string | number): WrappedString {
  const value = typeof (text) === 'string' ? text : String(text);

  return { Value: value };
}

export function booleanWrapper(value: boolean): WrappedBoolean {
  return { Value: value };
}

export function getAssetsPath(path: string): string {
  if (!path) {
    return '';
  }
  path = path.trim();
  if (path.startsWith('http')) {
    return path;
  }

  return `${environment.imageBasePath}${path.startsWith('/') ? '' : '/'}${path}`;
}

export function getUrlBasePart(): string {
  const baseHref = environment.AppBaseHref.replace(RegExp('\/$'), '');

  return `${location.origin}${baseHref}`;
}

export function fromServerDate(dateString: string): Date {
  return DateTime.fromISO(dateString.split('T')[0]).toJSDate();
}

export function toServerDate(localDate: Date): string {
  return DateTime.fromJSDate(localDate).toISODate() || '';
}

export function removeTrailingSlash(str: string): string {
  if (str.endsWith('/')) {
    return str.slice(0, -1);
  }

  return str;
}

export function fixModalOpenClass() {
  document.body.classList.remove('modal-open');
  document.body.style.setProperty('overflow-y', '');
}

/**
 * @param min min number that can show up (inclusive)
 * @param max max number that can show up (inclusive)
 */
export function randomIntFromInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function createCircularReplacer(): (key: string, value: any) => any {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
}

